import imc_select from "./imc_select";
import store from '../../../store'

jQuery('#imc_filter .form-group .vue_select').each(function() {
    new Vue({
        store,
        name : "imc_filter",
        el:this,
        data () {
            return {

            }
        },
        created () {

        },
        components : {
            imc_select
        }
    });
});
